/*=========================================================================================
  File Name: moduleStripe.js
  Description: Stripe Module
  ----------------------------------------------------------------------------------------
  This file is for adding stripe functionality to Vuejs application.
==========================================================================================*/

import state from './moduleStripeState.js'
import mutations from './moduleStripeMutations.js'
import actions from './moduleStripeActions.js'
import getters from './moduleStripeGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
